import React, { useEffect, useState } from "react";

import * as images from "../../constants/Images";
import Avatar from "react-avatar";
import AddComment from "../AddComment/AddComment";
import AddAnswer from "../AddAnswer/AddAnswer";
//import { ShowAttachment, setBookmarkImage } from "../DataCards/DataCards";
import { ShowAttachment, setBookmarkImage } from "../DataCards2/DataCards2";
import PropTypes from "prop-types";
import { format } from "date-fns";
//import { base_url } from "../../constants/ApiEndpoints";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Main from "../Main/Main";
import CommonService from "../../services/CommonService";
import BookmarksService from "../../services/BookmarksService";

import DetailsService from "../../services/DetailsService";
import Loadspinner from "../Loadspinner";
import { Link } from "react-router-dom";
//import { socket } from "../../common/Socket";
import Decrypt from "../../services/Decryption";
import Encrypt from "../../services/Encryption";
import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { green } from "@mui/material/colors";
import { createUserNameTaggedLocationString } from "../DataCards2/DataCards2";
import { APICall, APICallFormDataPOST } from "../../helpers/API/APICalls";
import { likeDislike } from "../../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";
import { decryptV2 } from "../../helpers/Cryptography/CryptoV2";
import { getuploadedvideo } from "../../helpers/API/APIEndPoints";
import axios from "axios";

function ShowDetails(props) {
  const [isEmpty, setEmpty] = useState(true);
  const [data, setDetails] = useState({});
  const [like, setLike] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [systemList, setSystemList] = useState([]);
  const [transcriptionData, setTranscriptionData] = useState([]);
  const [creatorId, setCreator] = useState();
  const [showItemId, setShowItemId] = useState(false);

  const knowledgeDetailsData = localStorage.getItem("knowledgeDetailsData")
    ? JSON.parse(getFromEncLocalStorage("knowledgeDetailsData"))
    : props.location.state;

  const mypath = knowledgeDetailsData
    ? knowledgeDetailsData?.from
    : props.location.pathname;

  const [value, setValue] = useState(0);

  useEffect(() => {
    getSystem();
    getDetails();
    let creator = getFromEncLocalStorage("employeenumber");
    setCreator(creator);
  }, []);

  useEffect(() => {
    getSystem();
    getDetails();
  }, [props]);

  useEffect(() => {
    if (showItemId) {
      const showItemIdTimer = setTimeout(() => {
        setShowItemId(false);
      }, 5000);
      return () => clearTimeout(showItemIdTimer);
    }
  }, [showItemId]);

  const getDetails = async () => {
    let detailsData = {
      isKnowledge: knowledgeDetailsData?.isKnowledge,
      id: knowledgeDetailsData?.id,
    };
    setLoading(true);
    const res = await DetailsService.getDetails(detailsData);

    if (res && res?.length > 0) {
      const updatedRes = await Promise.all(res.map(async (item) => {
        if (item?.attachment_file_name && item.attachment_file_type?.includes("video")) {
          const formData = new FormData();
          formData.append("fileName", item.attachment_file_name);
          let response = await APICallFormDataPOST(getuploadedvideo, formData);
          item.VideoUrl = response?.data?.data;
        }
        return item;
      }));
      let newDetails = updatedRes[0];
      createUserNameTaggedLocationString(newDetails);
      setDetails(newDetails);
      setLoading(false);
      setEmpty(false);
      let str1 = newDetails.transcription_data;
      if (str1) {
        let rets = str1.replace("/", "");
        let json_trans = JSON.parse(rets);
        setTranscriptionData(json_trans.transcript);
      }
    }
  };

  const formatDate = (date) => {
    let reqDate = new Date(date);
    return format(reqDate, "MMMM dd, yyyy HH:mm");
  };

  //const history = useHistory();

  const handleLike = async (isKnowledge, id, creator) => {
    setLike(!like);
    let likeKnowledgeData = {
      knowledge_id: id,
      created_by_id: creator,
    };
    let likeQuestionData = {
      question_id: id,
      created_by_id: creator,
    };

    let likeData = isKnowledge ? likeKnowledgeData : likeQuestionData;

    // let eData = JSON.stringify({ data: likeData, encryptionType: true });
    // let encryptedData = Encrypt(eData);
    // let newData = {
    //   data: encryptedData,
    // };
    // window.socketObj.emit("UpvoteSocket", newData);

    // window.socketObj.on("UpvoteBroadcast", (data) => {
    //   setUpvotes(data);
    // });

    const employeeNum = getFromEncLocalStorage("employeenumber");
    const firstName = getFromEncLocalStorage("firstname");
    const lastName = getFromEncLocalStorage("lastname");

    const likeDislikeData = {
      knowledge_id: null,
      question_id: null,
      answer_id: null,
      knowledge_base_id: null,
      created_by_id: creator,
      loggedin_userid: employeeNum,
      commenter_name: `${firstName} ${lastName}`,
    };
    // if (props?.knowledgeBaseId) {
    //   likeDislikeData.knowledge_base_id = props?.knowledgeBaseId;
    // } else
    if (isKnowledge) {
      likeDislikeData.knowledge_id = `${id}`;
    } else {
      likeDislikeData.question_id = `${id}`;
    }

    const resp = await APICall(likeDislike, likeDislikeData);

    setUpvotes(resp.data);
  };

  const setUpvotes = (res) => {
    let dataObj = res; //Decrypt(res.data);
    let respnseObj = dataObj; //JSON.parse(dataObj);
    let question_id = respnseObj.id.question_id;
    let knowledge_id = respnseObj.id.knowledge_id;
    let knowledge_base_id = respnseObj.id.knowledge_base_id;
    let data_temp = data;
    if (knowledge_id != undefined && knowledge_id != null) {
      if (data_temp.id == knowledge_id && respnseObj.IsSucessful) {
        if (respnseObj.status == "Upvoted") {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [respnseObj.data],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          }
        } else {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          }
        }
      }
      //console.log(`Inside setUpvotes data_temp: `, data_temp)
      setDetails(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    } else if (question_id != undefined && question_id != null) {
      if (data_temp.id == question_id && respnseObj.IsSucessful) {
        if (respnseObj.status == "Upvoted") {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [respnseObj.data],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          }
        } else {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          }
        }
      }
      //console.log(`Inside setUpvotes question_id data_temp: `, data_temp)
      setDetails(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    } else if (knowledge_base_id != undefined && knowledge_base_id != null) {
      if (data_temp.id == knowledge_base_id && respnseObj.IsSucessful) {
        if (respnseObj.status == "Upvoted") {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [respnseObj.data],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 1,
            };
          }
        } else {
          if (respnseObj.id.employeenumber === creatorId) {
            data_temp = {
              ...data_temp,
              likes_histories: [],
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          } else {
            data_temp = {
              ...data_temp,
              upvotes: respnseObj.upVote.upvotes,
              isLikedByMe: 0,
            };
          }
        }
      }
      //console.log(`Inside setUpvotes data_temp: `, data_temp)
      setDetails(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    }
  };

  const handleAnswerLike = async (id, creator) => {
    // let data = {
    //   answer_id: id,
    //   created_by_id: creator,
    // };
    // let eData = JSON.stringify({ data: data, encryptionType: true });
    // let encryptedData = Encrypt(eData);
    // let newData = {
    //   data: encryptedData,
    // };
    // window.socketObj.emit("UpvoteSocket", newData);

    // window.socketObj.on("UpvoteBroadcast", (data) => {
    //   setAnswerUpvotes(data);
    // });

    const employeeNum = getFromEncLocalStorage("employeenumber");
    const firstName = getFromEncLocalStorage("firstname");
    const lastName = getFromEncLocalStorage("lastname");

    const likeDislikeData = {
      knowledge_id: null,
      question_id: null,
      answer_id: `${id}`,
      knowledge_base_id: null,
      created_by_id: creator,
      loggedin_userid: employeeNum,
      commenter_name: `${firstName} ${lastName}`,
    };

    const token = getFromEncLocalStorage("token");
    const resp = await invokeApi(likeDislike, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      payload: likeDislikeData,
    });

    setAnswerUpvotes(resp);
  };

  const setAnswerUpvotes = (res) => {
    let dataObj = Decrypt(res.data);
    let respnseObj = JSON.parse(dataObj);
    let data_temp = data;

    data_temp.answer_data.map((answer) => {
      if (answer.id == respnseObj.id.answer_id) {
        if (respnseObj.status == "Upvoted") {
          if (respnseObj.id.employeenumber === creatorId) {
            answer.likes_histories = [respnseObj.data];
            answer.answer_upvote = respnseObj.upVote.answer_upvote;
          } else {
            answer.answer_upvote = respnseObj.upVote.answer_upvote;
          }
        } else if (respnseObj.status == "DownVoted") {
          if (respnseObj.id.employeenumber === creatorId) {
            answer.likes_histories = [];
            answer.answer_upvote = respnseObj.upVote.answer_upvote;
          } else {
            answer.answer_upvote = respnseObj.upVote.answer_upvote;
          }
        }
      }
    });

    // if (respnseObj.status == "Upvoted") {
    //   if (respnseObj.employeenumber == creatorId) {
    //     answer.likes_histories = [respnseObj.data];
    //     answer.answer_upvote = respnseObj.upVote.answer_upvote;
    //   } else {
    //     answer.answer_upvote = respnseObj.upVote.answer_upvote;
    //   }
    // } else if (respnseObj.status == "DownVoted") {
    //   if (respnseObj.employeenumber == creatorId) {
    //     answer.likes_histories = [];

    //     answer.answer_upvote = respnseObj.upVote.answer_upvote;
    //   } else {
    //     answer.answer_upvote = respnseObj.upVote.answer_upvote;
    //   }
    // }

    setDetails(data_temp);
    setValue(value + 1);
  };


  const setComments = (respnseObj) => {
    //let respnseObj = JSON.parse(Decrypt(res.data));
    let knowledge_id = respnseObj.data.knowledge_id;
    if (respnseObj.IsSucessful) {
      let data_temp = data;
      if (
        data_temp.id == knowledge_id &&
        data_temp.isKnowledge == 1 &&
        data_temp.comment_data.length === respnseObj.count - 1
      ) {
        data_temp.comment_data = [respnseObj.data, ...data_temp.comment_data];
      }
      setDetails(data_temp);
      setValue(value + 1);
    }
  };

  const setAnswers = (respnseObj) => {
    // let respnseObj = JSON.parse(Decrypt(res.data));
    let question_id = respnseObj.data.question_id;
    if (respnseObj.IsSucessful) {
      let data_temp = data;
      if (
        data_temp.id == question_id &&
        data_temp.isKnowledge == 0 &&
        data_temp.answer_data.length === respnseObj.count - 1
      ) {
        data_temp.answer_data = [respnseObj.data, ...data_temp.answer_data];
      }
      setDetails(data_temp);
      setValue(value + 1);
    }
  };

  const getSystem = async () => {
    setLoading(true);
    const res = await CommonService.getSystemList("");
    if (res) {
      setSystemList(res);
    }
    setLoading(false);
  };

  const updateBookmark = async (id, isKnowledge) => {
    let bookmarkKnowledgeData = {
      knowledge_id: id,
    };
    let bookmarkQuestionData = {
      question_id: id,
    };

    let bookmarkData = isKnowledge
      ? bookmarkKnowledgeData
      : bookmarkQuestionData;
    setLoading(true);
    const res = await BookmarksService.updateBookmarks(bookmarkData);

    if (!res) {
      alert(res.message);
    }
    setLoading(false);
    getDetails();
  };
  if (isEmpty) {
    return (
      <Main className="container">
        <Loadspinner
          filename="ShowDetails.js"
          isLoading={isLoading}
          isMiddle="true"
        />
      </Main>
    );
  }
  return (
    <Main active="details" className="container">
      <Loadspinner
        filename="ShowDetails.js"
        isLoading={isLoading}
        isMiddle="true"
      />
      {knowledgeDetailsData.redirected && (
        <Link
          to={{
            pathname: mypath,
            state: { from: mypath },
          }}
        >
          <ArrowBackIcon style={{ color: "black", cursor: "pointer" }} />
        </Link>
      )}

      <div className="card home-card">
        <div className="card-body">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-6 d-flex">
              {data.creator_profile_pic ? (
                <img
                  src={data.creator_profile_pic}
                  alt="Profile pic"
                  className="dp-img"
                />
              ) : (
                <Avatar name={data.creator} size="50px" round={true} />
              )}

              <div
                style={{ margin: "5px 0 0 10px" }}
                className="display-column"
                onDoubleClick={() => setShowItemId(true)}
              >
                <h6>
                  <b>{data?.creatorNameField?.[0]}</b>
                  <span className="small-text">
                    {data?.creatorNameField?.[1]}
                  </span>
                  <b>
                    {" "}
                    {data?.creatorNameField?.[2]}
                    {data?.creatorNameField?.[3]}
                  </b>
                  <span className="small-text">
                    {data?.creatorNameField?.[4]}
                  </span>
                </h6>
                <p className="small-text text-danger font-weight-bold">
                  {data?.creatorNameField?.[5]}
                </p>
                <p className={`small-text ${showItemId ? "" : "d-none"}`}>
                  {data.id}
                </p>
                <p className={`small-text ${showItemId ? "" : "d-none"}`}>
                  {data?.KnowledgeStatusText}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 col-xs-6 d-flex flex-column align-items-center flex-wrap align-content-end">
              {/* <img src={images.dots} className="card-dots" /> */}
              <div className="row">
                <div className="col">
                  {[8].includes(data?.VerificationStatus) && (
                    <CheckCircleIcon
                      width={10}
                      height={10}
                      sx={{ color: green[500] }}
                    />
                  )}
                </div>
                <div className="col">
                  <img
                    src={setBookmarkImage(
                      data.isKnowledge,
                      data.attachment_file_type,
                      data?.isBookmarkedByMe ||
                      data?.bookmarked_histories?.length > 0
                    )}
                    style={{
                      cursor: "pointer",
                      width: "2rem",
                      marginTop: "-1rem",
                    }}
                    onClick={() => {
                      updateBookmark(data.id, data.isKnowledge);
                      //forceUpdate();
                    }}
                    // className="card-banner"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Bookmark"
                  />
                </div>
                {data.status == 1 ? (
                  <div className="col">
                    <img
                      src={images.bookmark_filled}
                      className="bookmark-filled"
                    />
                    <div className="text-image">Proven</div>
                  </div>
                ) : null}
              </div>
              <div className="row">
                <div className="card-profile-right-time small-text">
                  {systemList.length == 0
                    ? null
                    : systemList.map((system) =>
                      system.id == data.system_id ? (
                        <span key={system.id}>{system.system_desc}</span>
                      ) : null
                    )}
                  <span> | </span>
                  <span>
                    {data?.created_date &&
                      format(
                        new Date(data?.created_date),
                        "MMMM dd, yyyy HH:mm"
                      )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <h6
            style={{ margin: "15px 0 5px 0" }}
            onClick={() => {
              // setDetails(data.id, data.isKnowledge);
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="View details"
          >
            <b>
              {/* {data.title.length > 60
                ? data.title.substring(0, 60) + "..."
                : data.title} */}
              {data.title}
            </b>
          </h6>
          <small
            className="card-text"
            onClick={() => {
              // setDetails(data.id, data.isKnowledge);
            }}
            style={{ marginBottom: "5px" }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="View details"
          >
            {/* {data.description.length > 160
              ? data.description.substring(0, 160) + "..."
              : data.description} */}
            {data.description}
          </small>
          {(data.attachment_file_type !== null && data.attachment !== null) ||
            (data.video_id != null && data.video_id != "") ? (
            <ShowAttachment
              ThumbnailGcp={data?.thumbnail}
              GcpVideoUrl={data?.VideoUrl}
              aType={data.attachment_file_type}
              attachment={data.attachment}
              videoId={data.video_id}
              thumbnailId={data.thumbnailId}
              thumbnail={data.thumbnail}
              videoMetadata={data.VideoMetadata}
            />
          ) : null}
          {data.transcription_data != null &&
            data.transcription_data != "{}" &&
            data.transcription_data != "" ? (
            <div className="row">
              <div className="col-8"></div>
              <div className="col-4">
                <a
                  className="transcript-link"
                  style={{ float: "right" }}
                  onClick={() => {
                    // setDetails(data.id, data.isKnowledge);
                  }}
                >
                  View Transcript
                </a>
              </div>
            </div>
          ) : null}
          <div className="d-flex flex-wrap">
            {data?.hashtags &&
              data?.hashtags?.split(",")?.map((ht, htIdx) => {
                return (
                  <div key={`key_${htIdx}`} className="px-2 py-1">
                    <Chip label={`#${ht}`} className="hashtag-chip" />
                  </div>
                );
              })}
          </div>

          <div className="justify-space-between" style={{ marginTop: "10px" }}>
            <div
              className="card-like"
              style={{ cursor: "pointer" }}
              onClick={() =>
                handleLike(data.isKnowledge, data.id, data.created_by_id)
              }
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={data.isKnowledge ? "Like" : "Upvotes"}
            >
              <img
                src={
                  data.likes_histories.length > 0
                    ? images.like_filled
                    : images.like
                }
                alt="like"
                className="like-img"
              />
              <small style={{ padding: "5px" }}>
                {data.upvotes == null ? 0 : data.upvotes}
              </small>
              <h6 style={{ margin: "0 5px" }}>
                {data.isKnowledge ? "Likes" : "Upvotes"}
              </h6>
            </div>
            <div className="card-like">
              <img src={images.comment} alt="comment" className="like-img" />
              <h6 style={{ margin: "0 5px" }}>
                {data.isKnowledge ? "Comments" : "Answers"}
              </h6>
              <small>
                (
                {data.isKnowledge
                  ? data.comment_data.length
                  : data.answer_data.length}
                )
              </small>
            </div>
          </div>
          <hr />
          {data.isKnowledge ? (
            data.comment_data && data.comment_data.length > 0 ? (
              <div className="display-col">
                <h5>Comments</h5>
                <div style={{ marginTop: "10px" }}>
                  {data.comment_data.map((comment) => (
                    <div className="display-col" key={comment.id}>
                      <div className="display-row justify-space-between">
                        <div className="display-row">
                          <Avatar
                            name={comment.commenter_name}
                            size="30px"
                            round={true}
                          />
                          <h6 style={{ margin: "auto", marginLeft: "5px" }}>
                            {comment.commenter_name}
                          </h6>
                        </div>
                        <small style={{ margin: "auto 0" }}>
                          {format(
                            new Date(comment.created_date),
                            "MMMM dd, yyyy HH:mm"
                          )}
                        </small>
                      </div>
                      <p>{comment.comment}</p>
                      <hr />
                    </div>
                  ))}
                </div>
              </div>
            ) : null
          ) : data.answer_data && data.answer_data.length > 0 ? (
            <div className="display-col">
              <h5>Answers</h5>
              <div style={{ marginTop: "10px" }}>
                {data.answer_data.map((answer) => (
                  <div className="display-col" key={answer.id}>
                    <div className="display-row justify-space-between">
                      <div className="display-row">
                        <Avatar
                          name={answer.creator}
                          size="30px"
                          round={true}
                        />
                        <h6 style={{ margin: "auto", marginLeft: "5px" }}>
                          {answer.creator}
                        </h6>
                        {answer.is_expert == 1 ? (
                          <img
                            src={images.expert_badge}
                            className="expert-badge"
                          />
                        ) : null}
                      </div>
                      <small style={{ margin: "auto 0" }}>
                        {format(
                          new Date(answer.created_date),
                          "MMMM dd, yyyy HH:mm"
                        )}
                      </small>
                    </div>

                    <p>{answer.answer_description}</p>
                    <div
                      className="justify-space-between"
                      style={{ marginTop: "10px" }}
                    >
                      <div className="card-like">
                        <img
                          src={
                            answer.likes_histories.length > 0
                              ? images.like_filled
                              : images.like
                          }
                          alt="like"
                          className="like-img"
                          onClick={() =>
                            handleAnswerLike(answer.id, data.created_by_id)
                          }
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Upvote"
                        />

                        <small style={{ marginLeft: "5px" }}>
                          {answer.answer_upvote == null
                            ? ""
                            : answer.answer_upvote}
                        </small>
                        {!answer.answer_upvote ? (
                          ""
                        ) : (
                          <h6 style={{ margin: "0 5px" }}>
                            People find this useful
                          </h6>
                        )}
                      </div>
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {data.isKnowledge ? (
            <AddComment
              id={data.id}
              sendComment={setComments}
              isDetail={true}
              creator={data.created_by_id}
            />
          ) : (
            <AddAnswer
              id={data.id}
              sendAns={setAnswers}
              isDetail={true}
              creator={data.created_by_id}
            />
          )}
        </div>
      </div>
    </Main>
  );
}

export default ShowDetails;

ShowDetails.propTypes = {
  location: PropTypes.object,
};
